import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ApBaseComponent } from '../ap-base-component/index';
import { ApAlertService } from './ap-alert.service';
import { ApAlert, ApAlertType } from './ApAlert';

@Component({
  selector: 'ap-alert',
  styleUrls: ['./ap-alert.component.less'],
  templateUrl: 'ap-alert.component.html',
})
export class ApAlertComponent extends ApBaseComponent implements OnInit, OnDestroy {
  @Input() ids: string[];
  @Input() fade = true;
  @Output() alertRemoved = new EventEmitter<ApAlert>();

  alerts: ApAlert[] = [];
  alertErrors: ApAlert[] = [];

  constructor(private alertService: ApAlertService) {
    super();

    this.ids = [ alertService.defaultId ];
  }

  ngOnInit() {
    for (const id of this.ids) {
      this.alertService.onAlert(id).pipe(
        this.takeUntilDestroy(),
      ).subscribe((alert) => {
        this.addNewAlert(alert);
      });
      this.alertService.onClearAlert(id).pipe(
        this.takeUntilDestroy(),
      ).subscribe((alert) => {
        this.removeAlert(alert);
      });
      this.alertService.onClearErrors(id).pipe(
        this.takeUntilDestroy(),
      ).subscribe(clearId => {
        this.addNewErrorAlert(new ApAlert({ id: clearId }));
      });
    }
  }

  removeAlert(alert: ApAlert) {
    if (alert.type === ApAlertType.Error) {
      this.removeAlertError(alert);
      return;
    }
    if (!this.alerts.includes(alert)) return;

    if (this.fade) {
      const alertToRemove = this.alerts.find((x) => x === alert);
      if (alertToRemove) {
        alertToRemove.fade = true;
      }

      setTimeout(() => {
        this.alerts = this.alerts.filter((x) => x !== alert);
      }, 250);
    } else {
      this.alerts = this.alerts.filter((x) => x !== alert);
    }

    this.alertRemoved.emit(alert);
  }

  removeAlertError(alert: ApAlert) {
    if (!this.alertErrors.includes(alert)) return;

    if (this.fade) {
      const alertToRemove = this.alertErrors.find((x) => x === alert);
      if (alertToRemove) {
        alertToRemove.fade = true;
      }

      setTimeout(() => {
        this.alertErrors = this.alertErrors.filter((x) => x !== alert);
      }, 250);
    } else {
      this.alertErrors = this.alertErrors.filter((x) => x !== alert);
    }

    this.alertRemoved.emit(alert);
  }

  cssClass(alert: ApAlert) {
    if (!alert) return;

    const classes = [];

    const alertTypeClass = {
      [ApAlertType.Success]: 'alert alert-success alert-dismissable',
      [ApAlertType.Info]: 'alert alert-info alert-dismissable',
      [ApAlertType.Error]: 'alert alert-danger alert-dismissable',
      [ApAlertType.Warning]: 'alert alert-warning alert-dismissable',
    };

    classes.push(alertTypeClass[alert.type]);

    if (alert.fade) {
      classes.push('fade');
    }

    return classes.join(' ');
  }

  private addNewAlert(alert: ApAlert) {
    if (alert.type === ApAlertType.Error) {
      this.addNewErrorAlert(alert);
      return;
    }
    if (!alert.message) {
      this.alerts = this.alerts.filter(x => x.id !== alert.id);
      return;
    }

    this.alerts.push(alert);

    if (alert.autoClose && alert.autoCloseTimeout) {
      setTimeout(() => this.removeAlert(alert), alert.autoCloseTimeout);
    }
  }
  private addNewErrorAlert(alert: ApAlert) {
    if (!alert.message) {
      this.alertErrors = this.alertErrors.filter(x => x.id !== alert.id);
      return;
    }

    this.alertErrors.push(alert);

    if (alert.autoClose && alert.autoCloseTimeout) {
      setTimeout(() => this.removeAlertError(alert), alert.autoCloseTimeout);
    }
  }
}
